import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import ClientSection from "../components/Clients/ClientsList";
import ReviewsSection from "../components/Clients/Reviews";
import JoinUsBanner from "../components/SharedComponents/joinUsBanner";

const Clients = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Nos Clients Prizy | Ensemble renforçons l'expérience client</title>
        <meta
          name="description"
          content="Consultez la liste de nos clients et trouvez comment Prizy collabore avec des marques renommées pour offrir des cartes cadeaux de qualité. Ensemble, nous renforçons l'expérience client."
        />
      </Helmet>
      <ClientSection></ClientSection>
      <ReviewsSection></ReviewsSection>
      <JoinUsBanner
        pink={1}
        sousTitre={t("integrateclients")}
        buttonText={t("devenirclient")}
      ></JoinUsBanner>
    </>
  );
};

export default Clients;
